import { cx } from '@/utils/strings'

interface ShieldLoaderProps {
  containerHeight?: string | number
  shieldSize?: string
  className?: string
}

export default function ShieldLoader({ containerHeight, shieldSize, className }: ShieldLoaderProps) {
  return (
    <div className={`w-full flex justify-center items-center`} style={{ height: `${containerHeight}px` }}>
      <div
        className={cx(
          'animate-[beat_1.8s_ease-in-out_infinite] font-bwi text-primaryBlue py-3',
          shieldSize == undefined && 'text-[100px] leading-[100px]',
          shieldSize === 'Xsmall' && 'text-[20px]  leading-[20px]',
          shieldSize === 'Small' && 'text-[50px]  leading-[50px]',
          shieldSize === 'Medium' && 'text-[125px]  leading-[125px]',
          shieldSize === 'Large' && 'text-[150px] leading-[150px]',
          className
        )}
      >
        &#xe932;
      </div>
    </div>
  )
}
